<template>
<div>

	<div class="row fl-row-tabela">
		<div class="col-md-12">
			<p v-if="lista.length">
				Registros encontrados: {{totalItens}}
			</p>
			<div class="table-responsive card card-table">
				<table :class="tableClass" class="table fl-table table-borderless table-hover">
					<thead>
						<tr>
							<th :class="column.class"
								:style="column.style"
								:width="column.width"
								v-for="(column, index) in columns"
								:key="index">

								<a v-if="column.sortable" href="#" @click.prevent="ordernar(column.key)">
									<fa-icon icon="sort" v-show="columnOrder != column.key" />
									<fa-icon icon="sort-alpha-down" v-show="columnOrder == column.key && order == 'asc'" />
									<fa-icon icon="sort-alpha-up" v-show="columnOrder == column.key && order == 'desc' " />
									{{column.name}}
								</a>

								<div v-else>
									{{column.name}}
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in lista"  :key="index">
							<td v-for="(column, indexColumn) in item.columns" :key="indexColumn" :style="column.style" :class="column.class">
								<span v-if="column.clickable">
									<a href="#" v-if="column.event" @click.prevent="$emit(column.event, item)">
										<fa-icon v-if="column.icon" :icon="column.icon" :style="column.styleIcon" />
										<span v-if="column.html" v-html="column.html"></span>
									</a>

									<a  v-if="column.link" :href="column.link" :target="column.target">
										<fa-icon v-if="column.icon" :icon="column.icon" :style="column.styleIcon" />
										<span v-if="column.html" v-html="column.html"></span>
									</a>

								</span>
								<span v-else>
									<span v-if="column.array">
										<span v-for="(itArray, indexArray) in column.array" :key="indexArray" v-html="itArray"></span>
									</span>
									<fa-icon v-if="column.icon" :icon="column.icon" :style="column.styleIcon" />
									<span v-if="column.html" v-html="column.html"></span>
									<span v-else>{{column.value}}</span>
								</span>

							</td>
						</tr>
					</tbody>
					<tfoot v-if="!lista.length">
						<tr>
							<td :colspan="columns.length">
								Nenhum registro encontrado.
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>

	<div>
		<div class="col-xs-12">
			<nav aria-label="Page navigation">
				<ul class="pagination-margin pagination pagination-sm justify-content-center table-server-side__pagination">
					<li class="page-item" :class="{'disabled': currentPage == 1 }">
						<a class="page-link" href="#" @click.prevent="previous">
							<span aria-hidden="true">
								<fa-icon icon="angle-left" />
							</span>
						</a>
					</li>
					<li class="page-item" v-for="(item, index) in  pageNumbers"  :key="index"
						:class="{'active': item == currentPage}">
						<a v-if="pageNumbers[index] >= currentPage && pageNumbers[index]<=exibePage" href="#" class="page-link" @click.prevent="page(item)">{{item}}</a>
					</li>
					<li class="page-item" :class="{'disabled': currentPage == totalPages }">
						<a href="#" class="page-link" @click.prevent="next">
							<span aria-hidden="true"><fa-icon icon="angle-right" /></span>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</div>
</template>

<script>

import _ from 'lodash'

export default {

	props: {
		columns: {
			type: Array,
			required: true,
		},

		tableClass: {
			type: String,
			required: false,
		},

		columnStartSortable: {
			type: String,
			required: true
		},

		perPage: {
			type: Number,
			required: true,
		},

		showPerPage: {
			type: Boolean,
			default: true,
		},
	},

	data () {
		return {

			lista: [],
			columnOrder: "",
			totalItens: 0,
			totalPages: 0,
			pageNumbers: 0,
			currentPage: 1,
			order: "asc",
			start: 0,
			exibePage: 10,
		}
	},

	mounted() {
		this.columnOrder = this.columnStartSortable
		this.carregaDados()
	},

	methods: {

        atualizaItem(item){

            var index = _.findIndex(this.lista, o => {return o._object.id == item._object.id})

            if(index < 0){
                this.lista.push(item)
            } else {
                this.lista[index] = item
            }
        },

		carregaDados(){
			this.$emit('carrega-dados', this.columnOrder, this.order, this.perPage, this.start)
		},

		loadTable(list, qtd){
			this.lista = list

			this.geraPaginacao(qtd)
		},

		geraPaginacao(qtdItens) {
			this.totalItens = qtdItens
			this.totalPages = Math.ceil(this.totalItens / this.perPage)

			var temp = [];
			for (var i = 1; i <= this.totalPages; i++) {
				temp.push(i);
			}
			this.pageNumbers = temp
			if(this.pageNumbers.length < this.currentPage) {
				this.currentPage = 1
			}
		},

		reseta() {
			this.start = 0
			this.currentPage = 1
			this.carregaDados()
		},

		ordernar (coluna){

			this.columnOrder = coluna

			if(this.order == 'asc'){
				this.order = 'desc'
			} else{
				this.order = 'asc'
			}

			this.start = 0
			this.currentPage = 1

			this.carregaDados()
		},

		// quando clica no número da páginação
		page (page) {
			this.start = (page * this.perPage) - (this.perPage)
			this.currentPage = page


			this.exibePage = this.currentPage+9

			if(this.exibePage > this.totalPages)
				this.exibePage = this.totalPages

			this.carregaDados()
		},

		// quando clica na seta de próximo
		next () {

			if (this.currentPage == this.totalPages) {
				return false;
			}

			this.page(this.currentPage + 1)

			if(this.currentPage < this.totalPages)
				this.exibePage++

		},

		// quando clica na seta de voltar
		previous () {

			if (this.currentPage == 1) {
				return false
			}

			this.page(this.currentPage - 1)

			if(this.currentPage > 1)
				this.exibePage--
		},

	}
}
</script>

<style lang="css" scoped>
.table-server-side__pagination{
	margin:0px;
	flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/table-server-side/main.vue